"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getCurrentUser_1 = tslib_1.__importDefault(require("./getCurrentUser"));
/**
 * Returns a deserialized JSON Web Token (JWT) used to identitfy the user to a Firebase service.
 *
 * @param {boolean} forceRefresh  Force refresh regardless of token expiration
 * @returns {Promise<string>} Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 */
async function getFirebaseIdToken(forceRefresh) {
    let userToken;
    const currentUser = (0, getCurrentUser_1.default)();
    try {
        userToken = await currentUser.getIdToken(forceRefresh);
    }
    catch (err) {
        throw new Error(`can't get bearer Token ${err}`);
    }
    return userToken;
}
exports.default = getFirebaseIdToken;
